import { useRef } from "react";
import QuizFunnel from "@/components/QuizFunnel";
import MembershipPlans from "@/components/MembershipPlans";
import LeadCapture from "@/components/LeadCapture";
import FAQSection from "@/components/FAQSection";

export default function MembershipPage() {
  const bookRef = useRef(null);

  const scrollToBook = () => {
    bookRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div data-testid="membership-page" className="min-h-screen bg-[#0A0A0B]">
      {/* Hero */}
      <section className="relative pt-32 pb-16 md:pt-40 md:pb-20">
        <div className="px-6 md:px-12 lg:px-24 max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <div className="h-px w-12 bg-[#C5A059]" />
            <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#C5A059]">
              Memberships
            </span>
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-medium text-[#F3F4F6] leading-[1.1] mb-6">
            Invest in<br />
            <span className="text-[#C5A059]">yourself.</span>
          </h1>
          <p className="text-base md:text-lg text-[#A1A1AA] leading-relaxed font-light max-w-xl">
            Take the quiz to find your ideal plan, or browse our membership options below. 
            All plans include full mobile service, premium products, and a dedicated barber.
          </p>
        </div>
      </section>

      <QuizFunnel onComplete={scrollToBook} />
      <MembershipPlans onSelect={scrollToBook} />
      <div ref={bookRef}>
        <LeadCapture />
      </div>
      <FAQSection />
    </div>
  );
}
